import { realtimeValueSample } from '@/runtime/device-value-data'

const own = (value, key) => Object.prototype.hasOwnProperty.call(value, key)
const object = value => value && typeof value === 'object' && !Array.isArray(value)
const scalar = value => ['string', 'boolean'].includes(typeof value) || (typeof value === 'number' && Number.isFinite(value))

function queryOf (scope) {
  if (!object(scope) || typeof scope.deviceId !== 'string' || !scope.deviceId || typeof scope.propertyId !== 'string' || !scope.propertyId) {
    throw new Error('当前属性读取绑定不完整')
  }
  return { deviceId: scope.deviceId, property: scope.propertyId }
}

function timestampOf (value) {
  // 缺少时间不能用本机收包时间补齐，否则迟到帧会被误判为最新上报。
  if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') throw new Error('平台返回的属性时间不正确')
  const timestamp = Number(value)
  if (!Number.isSafeInteger(timestamp) || timestamp < 0 || !Number.isFinite(new Date(timestamp).getTime())) throw new Error('平台返回的属性时间不正确')
  return timestamp
}

function targetMatches (row, query) {
  if (!object(row)) return true // 原解析器负责报告属性结构损坏。
  return [['deviceId', query.deviceId], ['property', query.property], ['propertyId', query.property]].every(([key, expected]) =>
    !own(row, key) || row[key] === undefined || row[key] === null || String(row[key]) === expected)
}

function normalized (sample, query) {
  if (!sample || !targetMatches(sample.row, query)) return null
  // realTime 的 createValue 帧可不含设备／属性 ID；只在已经限定目标的订阅中补齐绑定。
  return { deviceId: query.deviceId, propertyId: query.property, timestamp: timestampOf(sample.timestamp),
    value: sample.row.value, formatValue: sample.row.formatValue,
    unit: typeof sample.row.unit === 'string' ? sample.row.unit : '', source: 'ws' }
}

/** 沿用 dashboard realTime/history=1 的 MeasurementValue 解析；订阅确认不视为属性。 */
export function realtimeControlObserved (envelope, scope) {
  const query = queryOf(scope)
  if (envelope && ['error', 'authError'].includes(envelope.type)) {
    const payload = envelope.payload
    const message = [envelope.message, typeof payload === 'string' ? payload : object(payload) ? payload.message : null]
      .find(value => typeof value === 'string' && value.trim())
    throw new Error(message ? message.trim().slice(0, 240) : envelope.type === 'authError'
      ? '实时属性订阅鉴权失败，请检查登录状态和设备访问权限' : '实时属性订阅失败，请重试')
  }
  if (envelope && envelope.payload && !targetMatches(envelope.payload.value, query)) return null
  if (envelope && envelope.payload) timestampOf(envelope.payload.timestamp)
  return normalized(realtimeValueSample(envelope, query), query)
}

/** 按平台数据时间合并；同时间以最新推送为准，迟到旧帧不能回滚 Switch 的当前值。 */
export function mergeControlObserved (current, incoming) {
  if (!incoming) return current
  const timestamp = timestampOf(incoming.timestamp)
  if (!current) return incoming
  if (current.deviceId !== incoming.deviceId || current.propertyId !== incoming.propertyId) return current
  const previous = timestampOf(current.timestamp)
  if (timestamp < previous) return current
  return incoming
}

/** 只识别物模型声明的原值和平台转换后的 Boolean；未知／空值返回 null，绝不隐式关机。 */
export function controlObservedBoolean (sample, property) {
  if (!sample || !object(property) || property.type !== 'boolean') return null
  const trueValue = own(property, 'trueValue') ? property.trueValue : true
  const falseValue = own(property, 'falseValue') ? property.falseValue : false
  if (!scalar(trueValue) || !scalar(falseValue) || Object.is(trueValue, falseValue)) return null
  // 平台实时 createValue 已经通过物模型 Converter，原生 Boolean 是规范状态，不能再按别名反转。
  if (typeof sample.value === 'boolean') return sample.value
  if (Object.is(sample.value, trueValue)) return true
  if (Object.is(sample.value, falseValue)) return false
  return null
}
